import { TextureSelect } from '../../Selects/TextureSelect/TextureSelect';
import { MacroParamsTable } from '../../Tables/MacroParamsTable/MacroParamsTable';
import type { DependentParam, TextureSoil } from '../../../types/parameters.types';

interface MacronutrientsTabProps {
	params: DependentParam[];
	texture: TextureSoil;
	isLoading: boolean;
	onTextureChange: (texture: TextureSoil) => void;
	onChange: (params: DependentParam[]) => void;
}

export const MacronutrientsTab = ({
	params,
	texture,
	isLoading,
	onTextureChange,
	onChange,
}: MacronutrientsTabProps) => (
	<>
		<TextureSelect value={texture} onChange={onTextureChange} />
		<MacroParamsTable params={params} texture={texture} isLoading={isLoading} onChange={onChange} />
	</>
);
